/**
 * Link Component
 */

import React, {
  forwardRef,
  ComponentType,
} from 'react';
import { withTheme } from 'styled-components';
import { AnchorElement } from './link.style';
import { LinkDecorationTypes, LinkProps, LinkTypes, LinkRef, } from './link.types';

const DEFAULT_DATA_ATTR = { 'data-testid': 'link' };

const Link: ComponentType<LinkProps>
= forwardRef(({
    url,
    ariaLabel,
    children,
    className,
    dataAttr = {},
    decoration = LinkDecorationTypes.NONE,
    download = false,
    downloadName,
    handlers = {},
    rel,
    target,
    type = LinkTypes.PRIMARY,
  }: LinkProps, ref: LinkRef) => {

  // Call the handler when the event is triggered
  const invokeHandler: Function = (type: string, e?: Event) => {
    handlers[type](e);
  };
  const handlerProps: object = {};
  Object.keys(handlers).forEach((key: string) => {
    handlerProps[key] = (e: Event) => { invokeHandler(key, e); };
  });

  // Construct the download attr
  const downloadAttr: boolean | string = download ? (downloadName || true) : false;
  const combinedDataAttr = {...DEFAULT_DATA_ATTR, ...dataAttr};
  return (
    <AnchorElement
      className= { className }
      download={ downloadAttr }
      href={ url }
      rel={ rel }
      target={ target }
      { ...combinedDataAttr }
      { ...handlerProps }
      aria-label= { ariaLabel }
      decoration={decoration}
      ref={ref}
      type={type}
    >
        { children }
    </AnchorElement>
  );
});

export default withTheme(Link);
